//
// Module for the partner sites edit view
//
rs.module("content/system/configuration/partnersites/edit",

    ["controls/components/event-banner"],

    function (eventBanner) {

        //
        // Initialize the module
        //
        function initialize(jsSelectors, ajaxUrl) {

            var form = $.js(jsSelectors.form);
            var generateNewKey = form.js(jsSelectors.generateNewKey);
            var secretAccessKey = form.js(jsSelectors.secretAccessKey);
            var secretAccessKeyLabel = form.js(jsSelectors.secretAccessKeyLabel);

            // generate a new secret key for the partner site
            generateNewKey.on('click', function () {
                $.get(ajaxUrl, {}).done(function (results) {
                    secretAccessKey.val(results.encrypted);
                    secretAccessKeyLabel.js("_masked-data").data("value", results.encrypted);
                    eventBanner.addInformationalMessages(`A new secret access key has been generated but will not go into effect until this record is saved.`)
                });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);